import React, { useEffect } from 'react';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import Users from '../../Users';
import Categories from '../../Categories';
import IsoCodes from '../../IsoCodes';
import DateRange from '../../DateRange';
import Historical from '../../Historical';
import Archived from '../../Archived';
import { Link, useNavigate } from 'react-router';
import { Button, Card, CardBody, Col, Container, Form, FormGroup, Spinner } from 'reactstrap';
import useFilter from '../../../hooks/useFilter';
import useNavBar from '../../../hooks/useNavBar';

export default function ISOSummaryReportForm() {
    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();
    const users = Users();
    const categories = Categories();
    const isoCodes = IsoCodes();
    const dateRange = DateRange();
    const historical = Historical();
    const archived = Archived();

    const { filter, setFilter } = useFilter();
    const { loading, setLoading } = useNavBar();
    

    const headers = 
    [
        "Full Name",
        "Email",
        "Department",
        "Personnel ID",
        "Rank",
        "Shift",
        "Station",
        "Division",
        "Battalion",
        "Company",
        "Platoon",
        "Bureau",
        "EMS Certification",
        "Total Hours",
    ];

    useEffect(() => {
        if (!users.loading && !isoCodes.loading && !dateRange.loading && !historical.loading && !archived.loading){
            setLoading(false);
        }

        const headersWithActive = users.includeInactiveUsers ? [...headers, "User Status"] : headers;

        setFilter({
            users: users.selectedUsers.map(user => user.value),
            groups: users.selectedGroups.map(group => group.value),
            categories: categories.selectedCategories,
            selectAllCategories: categories.selectAll,
            isoCodes: isoCodes.selected.map(code => code.value),
            headers: [...headersWithActive, ...isoCodes.isoCodes.map(code => code.label)],
            startDate: dateRange.startDate,
            endDate: dateRange.endDate,
            includeHistoricalCompletions: historical.includeHistoricalCompletions,
            includeArchivedCompletions: archived.includeArchivedCompletions,
            hasArchivedCompletions: archived.hasArchivedCompletions,

            selectAllUsers: users.selectAll,
            formUsers: users.users,            
            formGroups: users.groups,
            includeInactiveUsers: users.includeInactiveUsers,
            formCategories: categories.categories,
            formCategoryIds: categories.categoryIds,
            formExpandedCategories: categories.expandedCategories,
            formCodes: isoCodes.isoCodes
        });

        isoCodes.setAllowNullIsoCodesOption(false);
    }, [users.loading,
        users.selectAll,
        users.selectedUsers,
        users.users,
        users.selectedGroups,
        users.groups,
        users.includeInactiveUsers,
        categories.selectAll,
        categories.categories,
        categories.selectedCategories,
        categories.categoryIds,
        categories.expandedCategories,
        isoCodes.loading,
        isoCodes.selected, 
        isoCodes.isoCodes, 
        isoCodes.setAllowNullIsoCodesOption, 
        dateRange.loading,
        dateRange.startDate, 
        dateRange.endDate,
        historical.includeHistoricalCompletions,
        archived.includeArchivedCompletions,
        archived.hasArchivedCompletions
    ]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const sendfilter = (
            (
                { users, groups, categories, selectAllCategories, isoCodes, headers, startDate, endDate, includeHistoricalCompletions, includeArchivedCompletions, hasArchivedCompletions }) =>
                ({ users, groups, categories, selectAllCategories, isoCodes, headers, startDate, endDate, includeHistoricalCompletions, includeArchivedCompletions, hasArchivedCompletions })
        )(filter);

        try{
            await axiosPrivate.post('api/reports/isosummary', sendfilter);
            navigate('/reports');
        }
        catch(err){
            console.log(err);
        }
    }

    return (
        loading ? <Spinner variant="primary" animation="border" role="status" className='custom-spinner'/> :
        <Container>
            <Col>
                <FormGroup>                            
                    <Card>
                        <CardBody>
                            <FormGroup>
                                {users.render}
                            </FormGroup>
                        </CardBody>
                    </Card>  
                </FormGroup>
                    <FormGroup>
                        <Card>
                            <CardBody>
                                <FormGroup>
                                    {categories.render}
                                </FormGroup>
                            </CardBody>
                        </Card>
                    </FormGroup>
                <FormGroup>
                    <Card>
                        <CardBody>                 
                            <FormGroup>
                                {isoCodes.render}
                            </FormGroup>
                        </CardBody>
                    </Card>
                </FormGroup>  
                <FormGroup> 
                    <Card>
                        <CardBody>
                            <FormGroup>
                                {dateRange.render}
                            </FormGroup>
                        </CardBody>
                    </Card>  
                </FormGroup> 
                    {
                        historical.hasHistoricalCompletions ?
                            <FormGroup>
                                <Card>
                                    <CardBody>
                                        <FormGroup>
                                            {historical.render}
                                        </FormGroup>
                                    </CardBody>
                                </Card>
                            </FormGroup>
                            :
                            null
                    }
                    {
                        archived.hasArchivedCompletions ?
                            <FormGroup>
                                <Card>
                                    <CardBody>
                                        <FormGroup>
                                            {archived.render}
                                        </FormGroup>
                                    </CardBody>
                                </Card>
                            </FormGroup>
                            :
                            null
                    }
                </Col>
            <footer>
                <Form onSubmit={handleSubmit}>
                    <Button color="primary">Generate Report</Button>
                    <Link to="/">
                        <Button className='btn-danger'>Back</Button>
                    </Link>
                </Form>
            </footer>
        </Container>
    );
}